import { getQueryKey } from "./utils";
const cacheUpdatedKey = "cacheUpdated";
export const emitCacheUpdateEvent = (entry) => {
    window.dispatchEvent(new CustomEvent(cacheUpdatedKey, { detail: entry }));
};
export const listenForCacheUpdate = (url, cb) => {
    const cacheUpdatedCallBack = async (e) => {
        const cacheKey = getQueryKey(url);
        if (cacheKey === e.detail.key) {
            const response = await e.detail.value;
            cb(response);
        }
    };
    window.addEventListener("cacheUpdated", cacheUpdatedCallBack);
    return () => window.removeEventListener("cacheUpdated", cacheUpdatedCallBack);
};
